import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions";
import service from "../../services/userManagement.service";
import axiosInterceptors from "../../hoc/axiosInterceptors";
import Textbox from "../../components/Textbox";
import Version from "../../components/Version";
import Button from "../../components/Button";
import ErrorMessage from "../../components/ErrorMessage";
import Logo from "../../components/Logo";
import joi from "joi";
import Form from "../../components/Form";
import "./Login.css";
import { Spinner } from "../../components";

class MfaLogin extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  initialState = {
    isSubmit: false,
    controls: {
      otp: {
        value: "",
        valid: false,
        validMessage: "",
        touched: false,
        validation: joi.string().required()
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    this.resetForm();
  }

  resetForm() {
    this.setState(this.initialState);
  }

  onSubmitHandler = event => {
    event.preventDefault();
    this.setState({ ...this.state, isSubmit: true });
    Object.keys(this.state.controls).map(controlName => {
      console.log(this.state.controls[controlName].valid);
      this.formIsValid =
        this.state.controls[controlName].valid && this.formIsValid;
    });
    console.log(this.formIsValid);
    if (this.formIsValid === true) {
      this.props.onMfaLogin(
        this.props.mfaSessionKey,
        this.state.controls.otp.value
      );
    }
  };

  checkValidity = (value, validation) => {
    let result = joi.validate(value, validation);
    return result;
  };

  formIsValid = false;

  onChangeHandler = (controlName, value) => {
    this.formIsValid = true;
    var validateResault = this.checkValidity(
      value,
      this.state.controls[controlName].validation
    );
    // this.formIsValid = validateResault.error ? false : true;
    const updatedControls = {
      ...this.state.controls,
      [controlName]: {
        ...this.state.controls[controlName],
        value: value,
        valid: validateResault.error ? false : true,
        validMessage: validateResault.error
          ? validateResault.error.details[0].message
          : "",
        touched: true
      }
    };
    this.setState({ ...this.state, controls: updatedControls });
    console.log(this.state);
  };

  render() {
    console.log("MFA render");
    console.info(this.props.loginStatus);
    return (
      <div className="body text-center wrapper">
        <Form classNames="form-signin">
          {this.props.loading && <Spinner />}
          <Logo />
          <h1 className="h3 mb-3 font-weight-normal">Please sign in</h1>
          <Textbox
            type="text"
            label=""
            placeholder="OTP"
            id="otp"
            onChange={this.onChangeHandler}
            value={this.state.controls.otp.value}
            valid={this.state.controls.otp.valid}
            validMessage={this.state.controls.otp.validMessage}
            isSubmited={this.state.isSubmit}
          />
          <Button
            // disable={this.formIsValid ? "" : disabled}
            className="btn btn-lg btn-primary btn-block "
            type="submit"
            label="Sign in"
            onClick={event => this.onSubmitHandler(event)}
          />

          <div className="col-md-12 p-0 mt-3">
            <ErrorMessage
              //{...this.props}
              error={this.props.loginStatus.message}
              className="col-md-12"
            />
          </div>
          <Version />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    loginStatus: state.auth.loginStatus,
    mfaSessionKey: state.auth.mfaSessionKey
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onMfaLogin: (mfaSessionKey, otp) =>
      dispatch(actions.mfaLogin(mfaSessionKey, otp))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(axiosInterceptors(MfaLogin, service));
